import React, { memo, useState, useEffect } from 'react';
import { Modal, Space, Radio, Tooltip } from 'antd';
import SpnId from '@components/SpnID/SpnId';

const AddModal = ({ onCancel, onClick, showSpn, ...restProps }) => {
  const { addModuleConfig: addConfig } = restProps.configs;
  const [value, setValue] = useState('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const onChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue(addConfig.radios[0].value);
  }, [restProps.visible]);

  const resetRadio = () => {
    setValue(1);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      await onClick(value);
    } catch (e) {
      console.error(e);
    }
    resetRadio();
    onCancel();
    setConfirmLoading(false);
  };

  const handleCancel = () => {
    resetRadio();
    onCancel();
  };

  return (
    <Modal
      {...restProps}
      // forceRender
      okText="add"
      //   okButtonProps={{ disabled: !canSave }}
      cancelText="cancel"
      className="projecthome-sort-modal manage-module-add-modal"
      closeIcon={<span className="appkiticon icon-close-fill" />}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
    >
      <h3 className="add-title capitalize-title">{addConfig.addTitle}</h3>
      <div className="add-new">{addConfig.addNew}</div>
      <Radio.Group
        onChange={onChange}
        value={value}
        className="create-project-radio-group"
      >
        <Space direction="vertical">
          {addConfig.radios.map((item, i) => (
            <>
              <Radio value={item.value} key={item.text}>
                {item.text}
                {item.tipTitle && <Tip title={item.tipTitle} />}
              </Radio>
              {showSpn &&
              value?.includes?.('powerbi') &&
              item.value.includes('powerbi') ? (
                <SpnId classname="small" />
              ) : null}
            </>
          ))}
        </Space>
      </Radio.Group>
    </Modal>
  );
};
const Tip = (props) => (
  <Tooltip
    placement="right"
    title={props.title}
    overlayClassName="add-manage-form-tooltip"
  >
    <span className="appkiticon icon-information-fill approach-information-tooltip" />
  </Tooltip>
);

export default memo((props) => {
  const { text } = props;
  const [isModalShow, toggleModalShow] = useState(false);

  return (
    <>
      <div
        className="integration-nav-add-btn"
        onClick={() => {
          toggleModalShow(true);
        }}
      >
        <span className="appkiticon icon-circle-plus-fill a-font-24" />
        <span className="text">{text}</span>
      </div>

      <AddModal
        visible={isModalShow}
        onCancel={() => toggleModalShow(false)}
        {...props}
      />
    </>
  );
});
